import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as rootActions } from '../actions';
import { actions as productTypeActions } from '../../ProductType/actions';
import { NAME as PRODUCT_NAME } from '../reducer';
import { NAME as PRODUCT_TYPE_NAME } from '../../ProductType/reducer';
import { NAME as ROOT_NAME } from '../../Root/reducer';
import { isSaving } from '../../Root/saving';
import { NON_NEGATIVE, nonNegativeChange } from '../../Root/nonNegative';
import { Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

function mapStateToProps(state) {
  return {
    ...state[PRODUCT_NAME],
    productTypeState: state[PRODUCT_TYPE_NAME],
    // Идёт ли сохранение: кнопки блокируются на это время (иначе товар создаётся дважды).
    saving: isSaving(state[ROOT_NAME], 'PRODUCT_CREATE', 'PRODUCT_EDIT'),
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...rootActions,
      ...productTypeActions,
    },
    dispatch
  );

function validate(selector, addProduct) {
  let successFlag = 0;
  // Sowing Area validation
  if (!selector.state.sowingArea) {
    selector.setState({
      errorSowingArea: true,
      helperTextSowingArea: 'Введите площадь посева.',
    });
    successFlag--;
  } else {
    selector.setState({ errorSowingArea: false, helperTextSowingArea: '' });
    successFlag++;
  }
  // Gross Tax validation
  if (!selector.state.grossTax) {
    selector.setState({
      errorGrossTax: true,
      helperTextGrossTax: 'Введите валовый сбор.',
    });
    successFlag--;
  } else {
    selector.setState({ errorGrossTax: false, helperTextGrossTax: '' });
    successFlag++;
  }
  if (addProduct) {
    // Selected Type Id validation
    if (!selector.state.selectedTypeId) {
      selector.setState({ errorSelectedTypeId: true });
      successFlag--;
    } else {
      selector.setState({ errorSelectedTypeId: false });
      successFlag++;
    }
    if (successFlag === 3) {
      return true;
    }
  } else {
    if (successFlag === 2) {
      return true;
    }
  }
}

class CreateProduct extends React.Component {
  constructor(props) {
    super(props);
    props.getProductTypeList();
    this.state = {
      selectedTypeId: 0,
      sowingArea: '',
      grossTax: 0,
      remainder: 0,
      remainderMinus: 0,
      remainderPlus: 0,
      initialGrossTax: 0, // Для отслеживания начального значения валового сбора
      errorSowingArea: false,
      errorGrossTax: false,
      errorSelectedTypeId: false,
      helperTextSowingArea: '',
      helperTextGrossTax: '',
    };
    if (props.selected) {
      this.state = {
        ...this.state,
        sowingArea: props.selected.sowingArea,
        grossTax: props.selected.grossTax,
        remainder: props.selected.remainder,
        initialGrossTax: props.selected.grossTax, // Устанавливаем начальное значение валового сбора
      };
    }
  }

  handleGrossTaxChange = (e) => {
    const newGrossTax = e.target.value;
    this.setState({
      grossTax: newGrossTax,
      errorGrossTax: false,
      helperTextGrossTax: '',
    });
  };

  handleGrossTaxBlur = () => {
    if (
      this.state.remainder === 0 &&
      this.state.initialGrossTax === 0 &&
      this.state.grossTax !== 0
    ) {
      this.setState({ remainder: this.state.grossTax });
    }
  };

  render() {
    if (this.props.selected) {
      return (
        <Grid component={Paper} container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Typography variant="h5" align="center">
                Редактирование товара
              </Typography>
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={12}>
            <h3>{this.props.selected.name}</h3>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={12}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                error={this.state.errorSowingArea}
                helperText={this.state.helperTextSowingArea}
                label="Площадь посева"
                inputProps={NON_NEGATIVE}
                variant="outlined"
                defaultValue={this.props.selected.sowingArea}
                type="number"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Га</InputAdornment>,
                }}
                onChange={nonNegativeChange((e) =>
                  this.setState({
                    sowingArea: e.target.value,
                    errorSowingArea: false,
                    helperTextSowingArea: '',
                  }))}
              />
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={12}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                error={this.state.errorGrossTax}
                helperText={this.state.helperTextGrossTax}
                type="number"
                label="Валовый сбор"
                inputProps={NON_NEGATIVE}
                defaultValue={this.props.selected.grossTax}
                variant="outlined"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Tн</InputAdornment>,
                }}
                onChange={nonNegativeChange(this.handleGrossTaxChange)}
                onBlur={this.handleGrossTaxBlur}
              />
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={12}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                type="number"
                label="Остаток"
                value={this.state.remainder}
                variant="outlined"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Tн</InputAdornment>,
                }}
                onChange={(e) =>
                  this.setState({ remainder: e.target.value })
                }
              />
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                type="number"
                label="Вычесть"
                inputProps={NON_NEGATIVE}
                defaultValue="0"
                variant="outlined"
                onChange={nonNegativeChange((e) =>
                  this.setState({ remainderMinus: e.target.value }))}
              />
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                type="number"
                label="Прибавить"
                inputProps={NON_NEGATIVE}
                defaultValue="0"
                variant="outlined"
                onChange={nonNegativeChange((e) =>
                  this.setState({ remainderPlus: e.target.value }))}
              />
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={6}>
            <FormControl fullWidth>
              <Button
                variant="contained"
                color="secondary"
                disabled={this.props.saving}
                onClick={() => {
                  this.props.editAction();
                }}
              >
                Отмена
              </Button>
            </FormControl>
          </Grid>
          <Grid style={this.state.gridItemStyle} item xs={6}>
            <FormControl fullWidth>
              <Button
                variant="contained"
                color="primary"
                disabled={this.props.saving}
                onClick={() => {
                  if (validate(this, false)) {
                    this.props.editProduct({
                      data: {
                        productType: this.props.selected.productType,
                        sowingArea: this.state.sowingArea,
                        grossTax: this.state.grossTax,
                        companyId: this.props.companyId,
                        remainder:
                          Number.parseInt(this.state.remainder) -
                          Number.parseInt(this.state.remainderMinus) +
                          Number.parseInt(this.state.remainderPlus),
                      },
                      backToProductList: this.props.editAction,
                    });
                  }
                }}
              >
                Сохранить
              </Button>
            </FormControl>
          </Grid>
        </Grid>
      );
    } else
      return (
        <>
          <Grid component={Paper} container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="h5" align="center">
                  Создание товара
                </Typography>
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="standard-select-currency"
                  select
                  label="Культура"
                  variant="outlined"
                  value={this.state.selectedTypeId}
                  error={this.state.errorSelectedTypeId}
                  onChange={(event) => {
                    this.setState({
                      selectedTypeId: event.target.value,
                      errorSelectedTypeId: false,
                    });
                  }}
                  helperText="Пожалуйста выберите тип товара"
                >
                  <MenuItem value="">
                    <em>Не выбрано</em>
                  </MenuItem>
                  {this.props.productTypeState.productTypeList.map((item) => {
                    let exist = this.props.productsList.find(
                      (element) => element.productType === item.id
                    );
                    if (!exist) {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    }
                  })}
                </TextField>
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  error={this.state.errorSowingArea}
                  helperText={this.state.helperTextSowingArea}
                  label="Площадь посева"
                  inputProps={NON_NEGATIVE}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">Га</InputAdornment>
                    ),
                  }}
                  onChange={nonNegativeChange((e) =>
                    this.setState({
                      sowingArea: e.target.value,
                      errorSowingArea: false,
                      helperTextSowingArea: '',
                    }))}
                />
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  error={this.state.errorGrossTax}
                  helperText={this.state.helperTextGrossTax}
                  type="number"
                  label="Валовый сбор"
                  inputProps={NON_NEGATIVE}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">Тн</InputAdornment>
                    ),
                  }}
                  onChange={nonNegativeChange(this.handleGrossTaxChange)}
                  onBlur={this.handleGrossTaxBlur}
                />
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={12}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  type="number"
                  label="Остаток"
                  value={this.state.remainder}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">Тн</InputAdornment>
                    ),
                  }}
                  onChange={(e) =>
                    this.setState({ remainder: e.target.value })
                  }
                />
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  type="number"
                  label="Вычесть"
                  inputProps={NON_NEGATIVE}
                  defaultValue="0"
                  variant="outlined"
                  onChange={nonNegativeChange((e) =>
                    this.setState({ remainderMinus: e.target.value }))}
                />
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  type="number"
                  label="Прибавить"
                  inputProps={NON_NEGATIVE}
                  defaultValue="0"
                  variant="outlined"
                  onChange={nonNegativeChange((e) =>
                    this.setState({ remainderPlus: e.target.value }))}
                />
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={6}>
              <FormControl fullWidth>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={this.props.saving}
                  onClick={() => {
                    this.props.editAction();
                  }}
                >
                  Отмена
                </Button>
              </FormControl>
            </Grid>
            <Grid style={this.state.gridItemStyle} item xs={6}>
              <FormControl fullWidth>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.props.saving}
                  onClick={() => {
                    if (validate(this, true)) {
                      this.props.createProduct({
                        data: {
                          productType: this.state.selectedTypeId,
                          sowingArea: this.state.sowingArea,
                          grossTax: this.state.grossTax,
                          companyId: this.props.companyId,
                          remainder: this.state.grossTax,
                        },
                        backToProductList: this.props.editAction,
                      });
                    }
                  }}
                >
                  Создать товар
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </>
      );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProduct);
